module.exports = __webpack_public_path__ + "fac526f8d21e5dd7763feb82ef78cad6.svg";